import styled from 'styled-components';
import { formElementErrorStyles, formElementFocusStyles, marginStyles, disabled } from '../../styles/components.js';

const StyledInput = styled.input `
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.borderRadii.small};
  border: 1px solid ${props => props.theme.colors.background.controls};
  box-sizing: border-box;
  color: ${props => props.theme.colors.content.primary};
  font-family: ${props => props.theme.fontFamilies.main.regular};
  font-size: ${props => props.theme.fontSizes[500]};
  height: 48px;
  line-height: ${props => props.theme.lineHeights.small};
  margin-top: 8px;
  padding: 0 16px;
  width: 100%;

  ${formElementErrorStyles}

  &:focus {
    ${formElementFocusStyles}
  }
`;
const InputGroup = styled.div `
  position: relative;
  width: 100%;

  ${props => marginStyles(props.margin)}

  &,
  input {
    cursor: ${props => props.disabled && 'not-allowed'};
  }

  ${props => props.disabled && disabled(props)}
`;

export { InputGroup, StyledInput };
